import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AccountCircle, Home, Lock, Person } from "@mui/icons-material";
import axios from "axios";
import {
  TextField,
  Button,
  Grid,
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Card,
  CardContent,
  Snackbar,
  Alert,
  MenuItem, InputAdornment, IconButton
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Navbar from "../layout/Navbar"; 
import "../../components/style.css";

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    ComID: "EH25",
    ReferralVia: sessionStorage.getItem("referralCode") || "",
    password: "",
    VendorType: "",
    firstName: "",
    lastName: "",
    DisplayName: "",
    Address: "",
    City: "",
    Province: "",
    Landmark: "",
    Country: "",
    phone: "",
    email: "",
    DOB: "",
    DOC: "",
    BkName: "",
    BkBranch: "",
    BkAcName: "",
    BkAcNo: "",
    BkAcType: "",
    NomName: "",
    NomRelation: "",
    NomMobile: "",
    PVValue: 100,
    CurrPCB: "Active",
    CurrRAB: "Valid",
  });

  const [activeStep, setActiveStep] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleBlur = () => {
    if (formData.email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      setError(true);
      setErrorMessage("Invalid email format");
    }
  };
  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Validate Mobile Number
    if (name === "phone") {
      if (!/^\d{0,10}$/.test(value)) {
        return; // Prevent invalid characters
      }
    }
  
    setFormData({ ...formData, [name]: value });
    setError(false);
    setErrorMessage("");
  };
  

  // Handle Next & Back Steps
  const handleNext = () => {
    if (activeStep === 0) {
      if (
        !formData.firstName ||
        !formData.lastName ||
        !formData.email ||
        !formData.phone ||
        !formData.password ||
        !formData.VendorType ||
        !formData.DOB 
        // !formData.DOC 
        // !formData.ReferralVia
      ) {
        setSnackbar({ open: true, message: "Please fill all required fields in Personal Info", severity: "error" });
        return; // Stop user from going to the next step
      }
    }
  
    setActiveStep((prevStep) => prevStep + 1);
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };
  
  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

  // Handle API Call on Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await axios.post("https://testing.esnep.com/magnessa/api/vendor/register", formData, {
        headers: { "Content-Type": "application/json" },
      });
  
      // Check the status code from the backend
      if (response.data.StatusCode === 200) {
        setSnackbar({ open: true, message: response.data.Message, severity: "success" });
        setTimeout(() => navigate("/login"), 2000); // Redirect after success
      } else if (response.data.StatusCode === 201) {
        setSnackbar({ open: true, message: response.data.Message, severity: "error" });
      } else {
        throw new Error("Registration failed. Please try again.");
      }
    } catch (error) {
      setSnackbar({ open: true, message: error.response?.data?.Message || "An error occurred.", severity: "error" });
    }
  };

  // Stepper Configuration
  const steps = [
    { label: "Personal Info", icon: <Person /> },
    { label: "Address", icon: <Home /> },
    { label: "Bank Details", icon: <Lock /> },
    { label: "Nominee", icon: <AccountCircle /> },
  ];

  // Get step content
  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} required />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} required />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth label="Email" name="email" type="email" value={formData.email} onChange={handleChange} required  onBlur={handleBlur}  error={error}
          helperText={errorMessage} // Show error only when focus is lost
           />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth label="Mobile No." name="phone" type="tel" value={formData.phone} onChange={handleChange} required />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth label="Password" name="password" type="password" value={formData.password} onChange={handleChange} required />
            </Grid>
            <Grid item xs={4}>
              <TextField
                select
                fullWidth
                label="Vendor Type"
                name="VendorType"
                value={formData.VendorType}
                onChange={handleChange}
                required
              >
                <MenuItem value="SUN">Sun</MenuItem>
                <MenuItem value="MOON">Moon</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth label="DOB" name="DOB" type="date" value={formData.DOB} onChange={handleChange} InputLabelProps={{ shrink: true }} required />
            </Grid>
            <Grid item xs={4}>
  <TextField
    fullWidth
    label="Upload Document"
    value={selectedFile ? selectedFile.name : ""}
    InputProps={{
      readOnly: true,
      endAdornment: (
        <InputAdornment position="end">
          <input
            accept=".pdf,.doc,.docx,.jpg,.png"
            style={{ display: "none" }}
            id="upload-button-file"
            type="file"
            onChange={handleFileChange}
          />
          <label htmlFor="upload-button-file">
            <IconButton component="span">
              <CloudUploadIcon />
            </IconButton>
          </label>
        </InputAdornment>
      ),
    }}
  />
</Grid>

          
          </Grid>
        );
      
      case 1:
        return (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField fullWidth label="Address" name="Address" value={formData.Address} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="City" name="City" value={formData.City} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="State/Province" name="Province" value={formData.Province} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Country" name="Country" value={formData.Country} onChange={handleChange} required />
            </Grid>
          </Grid>
        );

      case 2:
        return (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField fullWidth label="Bank Name" name="BkName" value={formData.BkName} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Account Number" name="BkAcNo" value={formData.BkAcNo} onChange={handleChange} required />
            </Grid>
          </Grid>
        );

      case 3:
        return (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField fullWidth label="Nominee Name" name="NomName" value={formData.NomName} onChange={handleChange} required />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Nominee Relation" name="NomRelation" value={formData.NomRelation} onChange={handleChange} required />
            </Grid>
          </Grid>
        );

      default:
        return <Typography>Error: Unknown Step</Typography>;
    }
  };

  return (
    <>
      <Navbar />
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh", backgroundColor: "#f5f5f5", p: 2 }}>
        <Card sx={{ width: "100%", maxWidth: 800, boxShadow: 1, borderRadius: 1, p: 2 }}>
          <CardContent>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((step, index) => (
                <Step key={index}>
                <StepLabel StepIconComponent={(props) => {
  const isActive = activeStep === index;
  return React.cloneElement(steps[index].icon, { 
    fontSize: "large", 
    color: props.completed ? "primary" : isActive ? "primary" : "disabled" 
  });
}}>
  {step.label}
</StepLabel>

                </Step>
              ))}
            </Stepper>

            <Box sx={{ mt: 3 }}>{getStepContent(activeStep)}</Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
              {activeStep > 0 && <Button variant="contained" sx={{ backgroundColor: "#ff3c20" }} onClick={handleBack}>Back</Button>}
              {activeStep < steps.length - 1 ? (
                <Button variant="contained" sx={{ backgroundColor: "#232f3e" }} onClick={handleNext}>Next</Button>
              ) : (
                <Button variant="contained" color="success" onClick={handleSubmit}>Submit</Button>
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </>
  );
};

export default Register;
